import { render, staticRenderFns } from "./BridgePhotosFolderView.vue?vue&type=template&id=1be4ebd6"
import script from "./BridgePhotosFolderView.vue?vue&type=script&lang=ts"
export * from "./BridgePhotosFolderView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports